﻿

/*------------------------------------*\
    #MY-AGREEMENTS
\*------------------------------------*/

window.gro = window.gro || {};
gro.modules = gro.modules || {};


gro.modules.myAgreements = (function () {
    var priv = {};

    /**
     * Private initialization method
     */
    priv.init = function () {

        $(document).on("click", "#openPdf", function (e) {
            e.preventDefault();
            var idValue = $(this).data("id");
            var vismaId = $(this).data("vismaid");
            var currentPageId = $("#CurrentPageId").val();
            var agreementNumber = $(this).data("agreementnumber");

            var form = $("<form>")
                .attr("method", "post")
                .attr("action", "/api/agreementpdf/ViewAgreement")
                .attr("target", "_blank");

            var hiddenField1 = $("<input>")
                .attr("type", "hidden")
                .attr("name", "transid")
                .val(idValue);

            var hiddenFieldVismaId = $("<input>")
                .attr("type", "hidden")
                .attr("name", "vismaId")
                .val(vismaId);

            var hiddenField2 = $("<input>")
                .attr("type", "hidden")
                .attr("name", "pageId")
                .val(currentPageId);

            var hiddenField3 = $("<input>")
                .attr("type", "hidden")
                .attr("name", "agreementnumber")
                .val(agreementNumber);

            form.append(hiddenField1).appendTo("body");
            form.append(hiddenField2).appendTo("body");
            form.append(hiddenField3).appendTo("body");
            form.append(hiddenFieldVismaId).appendTo("body");

            form.submit();
        });

    };

    // Initialize module

    $(function () {
        priv.init();
    });

})();
